export default __webpack_public_path__ + "assets/webgl/complete-7.5c839b92.jpg";